import React from 'react';
import {
  CalendarMonthOutlined,
  CalendarViewWeekOutlined,
  EventRepeatOutlined,
  InsertInvitationOutlined,
} from '@mui/icons-material';
import { Box, Button, Typography } from '@mui/material';
import { Colors } from '../../../assets/theme/Colors';
import {
  FREQUENCY_EVERY_OTHER_WEEK,
  FREQUENCY_MONTHLY,
  FREQUENCY_ONCE,
  FREQUENCY_WEEKLY,
} from '../../../models/donationsNew';

export const frquencyTypes = [
  {
    name: 'one-time',
    label: 'One Time',
    icon: <InsertInvitationOutlined />,
    value: FREQUENCY_ONCE,
  },
  {
    name: 'weekly',
    label: 'Weekly',
    icon: <EventRepeatOutlined />,
    value: FREQUENCY_WEEKLY,
  },
  {
    name: 'every-other-week',
    label: 'Every other week',
    icon: <CalendarViewWeekOutlined />,
    value: FREQUENCY_EVERY_OTHER_WEEK,
  },
  {
    name: 'monthly',
    label: 'Monthly',
    icon: <CalendarMonthOutlined />,
    value: FREQUENCY_MONTHLY,
  },
];

const RoutesFrequency = ({ onFrequencyChange, selectedFrequency }) => (
  <>
    <Typography variant="body2" sx={{ fontWeight: 700 }}>
      Frequency
    </Typography>
    <Box>
      {frquencyTypes.map((type) => {
        const frequencyActive = type.value === selectedFrequency;

        return (
          <Button
            key={type.name}
            startIcon={type.icon}
            variant="outlined"
            size="small"
            onClick={() => onFrequencyChange(type.value)}
            sx={{
              borderRadius: 2,
              py: 1,
              px: 2,
              mt: 1,
              mr: 1,
              textTransform: 'none',
              fontWeight: 700,
              color: frequencyActive ? Colors.appBar.main : 'text.primary',
              borderColor: frequencyActive ? Colors.appBar.main : 'text.disabled',
              bgcolor: frequencyActive ? '#fdeae5' : 'default',
              '&:hover': {
                color: Colors.appBar.main,
                borderColor: Colors.appBar.main,
                bgcolor: frequencyActive ? '#fdeae5' : '#fff',
                opacity: frequencyActive ? 0.7 : 1,
              },
            }}
          >
            {type.label}
          </Button>
        );
      })}
    </Box>
  </>
);

export default RoutesFrequency;
